import type { AxiosInstance } from 'axios';
import type { Subscription } from '../../types/Subscription';
import type { Account } from '../../types/Account';

export const AccountService = (api: AxiosInstance) => ({
  // Get own profile
  getAccount: async () => {
    const response = await api.get<Account>('/account');
    return response.data;
  },

  // Get available subscriptions
  getSubscriptions: async () => {
    const response = await api.get<Subscription[]>('/account/subscriptions');
    return response.data;
  },
}); 